function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.912 6c-2.553 0-4.566 2.243-4.37 4.87l.21 1.832c.048.635.224 1.23.502 1.758a37.54 37.54 0 00-2.63 1.338 3.136 3.136 0 00-1.615 2.634c-.043 1.354.052 2.497.561 4.86a.877.877 0 001.046.686.906.906 0 00.665-1.08c-.473-2.199-.558-3.188-.52-4.407.014-.442.268-.86.7-1.103a34.91 34.91 0 012.997-1.495 4.158 4.158 0 005.084 0c.64.277 1.79.818 2.997 1.495.432.242.686.66.7 1.103.038 1.22-.047 2.208-.52 4.408a.906.906 0 00.665 1.08c.473.108.941-.2 1.046-.688.509-2.363.604-3.505.56-4.859a3.135 3.135 0 00-1.614-2.634 37.548 37.548 0 00-2.63-1.338 4.487 4.487 0 00.501-1.758l.211-1.831C20.654 8.243 18.641 6 16.088 6h-.176zm0 1.81c-1.532 0-2.74 1.346-2.622 2.922l.21 1.832c.101 1.348 1.19 2.388 2.5 2.388s2.399-1.04 2.5-2.388l.21-1.832c.118-1.576-1.09-2.922-2.622-2.922h-.176z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 16c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2s14 6.268 14 14zm-2 0c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12z",
  fill: "currentColor"
})));